import { useEffect, useState } from "react";
import { currentUser, login, logout, onAuthChange } from "../lib/pocketbase";
import { runNgDiagnostic, runNgStatus } from "../services/ng-data";

export function NgStatus() {
  const [diagnostic, setDiagnostic] = useState(null);
  const [user, setUser] = useState(currentUser());
  const [loginOpen, setLoginOpen] = useState(false);
  const [identity, setIdentity] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [loginBusy, setLoginBusy] = useState(false);
  const diagnosticMode = window.location.hash === "#/diagnostic";

  useEffect(() => {
    let active = true;
    let retryTimer;
    let failedChecks = 0;
    const refreshDiagnostic = async () => {
      const result = await (diagnosticMode ? runNgDiagnostic() : runNgStatus());
      if (!active) return;
      if (result.health.connected) {
        failedChecks = 0;
        setDiagnostic(result);
        return;
      }
      failedChecks += 1;
      const status = Number(result.health.status || 0);
      if (status >= 400 && status < 500 || failedChecks >= 3) {
        setDiagnostic(result);
        return;
      }
      retryTimer = window.setTimeout(refreshDiagnostic, 2000);
    };
    void refreshDiagnostic();
    const removeAuthListener = onAuthChange(setUser);
    const requireAuth = () => setLoginOpen(true);
    window.addEventListener("ng-auth-required", requireAuth);
    return () => {
      active = false;
      window.clearTimeout(retryTimer);
      removeAuthListener?.();
      window.removeEventListener("ng-auth-required", requireAuth);
    };
  }, []);

  if (!diagnostic) return null;

  const submitLogin = async (event) => {
    event.preventDefault();
    setLoginBusy(true);
    setLoginError("");
    try {
      await login(identity, password);
      setUser(currentUser());
      setLoginOpen(false);
      setPassword("");
    } catch (error) {
      setLoginError(error?.response?.message || "Identifiant ou mot de passe incorrect.");
    } finally {
      setLoginBusy(false);
    }
  };

  if (diagnosticMode) {
    return (
      <div className="ng-diagnostic-layer">
        <section className="ng-diagnostic-card">
          <span className="ng-diagnostic-kicker">PORTAIL PHARMA NG</span>
          <h1>Diagnostic de connexion</h1>
          <p className={diagnostic.health.connected ? "ok" : "error"}>
            <i /> {diagnostic.health.connected ? "Base NG connectée" : "Connexion à la base NG impossible"}
          </p>
          <dl>
            <div><dt>Adresse utilisée</dt><dd>{diagnostic.url}</dd></div>
            <div><dt>Pharmacies</dt><dd>{diagnostic.counts.core_pharmacies ?? "Accès refusé"}</dd></div>
            <div><dt>Modules</dt><dd>{diagnostic.counts.core_modules ?? "Accès refusé"}</dd></div>
            <div><dt>Accès rapides</dt><dd>{diagnostic.counts.quick_tools ?? "Accès refusé"}</dd></div>
          </dl>
          <a href="/">← Retour au portail</a>
        </section>
      </div>
    );
  }

  return <>
    {diagnostic.health.connected && !user && <button type="button" className="ng-session-banner" onClick={() => setLoginOpen(true)}>
      🔒 Mode consultation — connectez ce poste une seule fois pour créer, modifier et importer
    </button>}
    <button className={`ng-account-pill ${user ? "connected" : ""}`} type="button" onClick={() => setLoginOpen(true)}>
      {user ? "✓ Poste connecté" : "🔐 Connecter ce poste"}
    </button>
    {loginOpen && <div className="ng-login-layer" role="presentation" onMouseDown={() => setLoginOpen(false)}>
      <section className="ng-login-card" role="dialog" aria-modal="true" aria-label="Connexion équipe" onMouseDown={(event) => event.stopPropagation()}>
        <button type="button" className="ng-login-close" aria-label="Fermer" onClick={() => setLoginOpen(false)}>×</button>
        <span>PORTAIL PHARMA NG</span>
        {user ? <>
          <h2>Poste connecté</h2>
          <p>Les ajouts, modifications et imports sont autorisés sur ce poste.</p>
          <button type="button" className="ng-login-submit" onClick={() => { logout(); setUser(null); setLoginOpen(false); }}>Se déconnecter</button>
        </> : <form onSubmit={submitLogin}>
          <h2>Connexion du poste</h2>
          <p>Une seule connexion partagée par ordinateur suffit. Les opérateurs continuent ensuite à choisir leur nom dans les modules.</p>
          <label><span>Adresse e-mail</span><input required autoFocus autoComplete="username" value={identity} onChange={(event) => setIdentity(event.target.value)} /></label>
          <label><span>Mot de passe</span><input required type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} /></label>
          {loginError && <div className="ng-login-error">{loginError}</div>}
          <button className="ng-login-submit" disabled={loginBusy}>{loginBusy ? "Connexion…" : "Se connecter"}</button>
        </form>}
      </section>
    </div>}
  </>;
}
